import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  //structureLength: 0,
  astructures: [],
  structures: {}
}

export default function funcStructureReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_FUNCIONAL_STRUCTURE:
      return {...state, loading: action.payload}
    case actions.GET_FUNCIONAL_STRUCTURE:
      return {...state, 
              structures: action.payload.structures, 
              astructures: action.payload.astructures,
              //structureLength: action.payload.structureLength
            }
    default:
      return state
  }
}